import { AddLine, Button, Col, MinusCircleIcon, PencilLineIcon, Row } from 'ui';
import { type GiveImageWithTitle, GivingImageWithTitle, GivingSummaryDetails } from '../../../../../components';
import { useGiveNow } from '../../../context';

type P = {
  getPathToGivingDetail?: (id: string) => string;
  giving: GiveImageWithTitle;
  onClick?: () => void;
};

const GiveNowItem = ({ getPathToGivingDetail, giving, onClick }: P) => {
  const { getItem, removeItem } = useGiveNow();
  const savedGive = getItem(giving.id);

  return (
    <Row className="option-summary" gutter={[0, 'xs']} key={giving.id}>
      <Col span={24}>
        <GivingImageWithTitle getPathToGivingDetail={getPathToGivingDetail} giving={giving} noStyle titleLevel={5} />
      </Col>

      {savedGive ? (
        <Col span={24}>
          <GivingSummaryDetails
            amount={savedGive.amount}
            displayName={savedGive.displayName}
            recurring={savedGive.recurring}
            type="giveNow"
          />
        </Col>
      ) : null}

      {onClick ? (
        <Col span={24}>
          <Row justify="space-between">
            {savedGive ? (
              <>
                <Col>
                  <Button icon={<PencilLineIcon />} onClick={onClick} size="small">
                    Edit
                  </Button>
                </Col>
                <Col>
                  <Button
                    danger
                    icon={<MinusCircleIcon />}
                    onClick={() => {
                      removeItem(giving.id);
                    }}
                    size="small"
                  >
                    Remove
                  </Button>
                </Col>
              </>
            ) : (
              <Col>
                <Button icon={<AddLine />} onClick={onClick} size="small">
                  Add amount
                </Button>
              </Col>
            )}
          </Row>
        </Col>
      ) : null}
    </Row>
  );
};

export default GiveNowItem;
